module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19DZhLg/tc-custom/9781618683236.jpg?1726617359155",
      "alt": "This image is the cover for the book Journal: Cracked Earth, The Journal Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Journal: Cracked Earth, The Journal Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A shocking natural disaster rocks the country. And only one woman is prepared to handle the fallout. A post-apocalyptic thriller series begins.")]), _c('br'), _c('br'), _c('b', [_vm._v("When a major crisis rocks the nation, supply lines are shut down everywhere. ")]), _c('br'), _c('br'), _c('b', [_vm._v("The small town of Moose Creek feels the effects almost immediately as they begin to run out of food.")]), _c('br'), _c('br'), _c('b', [_vm._v("In the remote regions of the Upper Peninsula of Michigan, the residents are hit again when the power is cut off to them in the middle of a brutal winter and they must struggle with one calamity after another, with the help of one woman")]), _c('br'), _c('br'), _c('b', [_vm._v("Allexa Smeth is their under-trained Emergency Manager, with problems of her own.")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deborah D. Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Deborah Moore lives a quiet life in the Upper Peninsula of Michigan with her cat, Tufts.  She was born and raised in Detroit, the kid of a cop, moved to a small town to raise her two young sons, then moved to an even smaller town to pursue her dreams of being self-sufficient and to explore her love of writing.  Being a life-long Prepper, Deborah has done numerous articles for magazines and speaking engagements on the subject.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Permuted Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0